/**
 * Dashboard Translations Module (Japanese)
 * Matches English structure exactly
 * @module dashboard
 * @language ja
 */

export const dashboard = {
  index: {
    heroTitle: "JCI開発評議会フューチャーズ・オブザーバトリー",
    heroSubtitle: "世界規模でユースリーダーシップ、メンタルヘルス、経済機会を測定",
    heroDescription: "114か国の若手リーダーの状況を分析するデータ駆動型プラットフォーム。JCIのグローバルネットワークと研究パートナーシップからの検証済みメトリクスを使用。",
    globalImpactTitle: "グローバルインパクト一覧",
    verifiedData: "JCIインパクトレポート2025からの検証済みデータ",
    globalMembers: "グローバルメンバー",
    activeWorldwide: "世界中でアクティブ",
    projects: "プロジェクト",
    period20242025: "期間: 2024-2025",
    volunteerHours: "ボランティア時間",
    hoursContributed: "貢献時間",
    countries: "国",
    worldwidePresence: "世界的プレゼンス",
    localOrganizations: "ローカル組織",
    activeCommunities: "アクティブコミュニティ",
    digitalReachTitle: "デジタルリーチとフットプリント",
    totalFollowers: "総フォロワー",
    jciccUsers: "jci.ccユーザー",
    memberDemographicsTitle: "会員デモグラフィックスナップショット",
    averageAge: "平均年齢",
    yearsOld: "歳",
    universityEducated: "大学教育",
    bachelorsOrHigher: "学士号以上",
    fullTime: "フルタイム",
    entrepreneurs: "起業家",
    employmentStatus: "雇用状況"
  },
  charts: {
    noDataAvailable: "データがありません",
    dataLoadingSoon: "データは間もなく読み込まれます",
    noFunnelData: "ファネルデータがありません",
    configureProcessData: "プロセスデータを設定してください",
    radarUnavailable: "レーダーデータが利用できません",
    configurePerformanceIndicators: "パフォーマンス指標を設定してください",
    performanceUnavailable: "パフォーマンスデータが利用できません",
    configureTrendData: "トレンドデータを設定してください",
    currentProgress: "現在の進捗",
    goal2040: "2040年目標",
    mainValue: "メインバリュー",
    trend: "トレンド",
    goal: "目標"
  },
  header: {
    title: "JCI開発評議会ユースフューチャーズ・オブザーバトリー",
    subtitle: "開発評議会グローバル・オブザーバトリー",
    tagline: "変化する世界のためのリーダー育成"
  },
  dashboard: {
    heroTitle: "JCI開発評議会ユースフューチャーズ・オブザーバトリー",
    heroSubtitle: "若者のリーダーシップ、メンタルヘルス、経済機会を測定する",
    heroDescription: "ユースフューチャーズ指数（YFI）を通じてグローバルな若者の機会を理解する",
    learnAboutFII: "YFIについて詳しく",
    globalReach: "グローバルリーチ",
    activeMembersWorldwide: "世界中のアクティブ会員",
    acrossCountries: "114カ国にわたり",
    localOrganizations: "ローカル組織",
    impactDelivered: "達成されたインパクト",
    beneficiariesReached: "受益者達成数 (2024-2025)",
    projectsImplemented: "実施されたプロジェクト",
    volunteerHours: "ボランティア時間",
    digitalPresence: "デジタルプレゼンス",
    socialFollowers: "ソーシャルメディアフォロワー",
    monthlyImpressions: "月間インプレッション",
    magazineReaders: "マガジン読者 (70カ国以上)",
    websiteEngagement: "ウェブサイトエンゲージメント",
    activeUsers: "jci.ccのアクティブユーザー",
    pageViews: "ページビュー",
    avgSessionDuration: "平均セッション時間",
    whatIsFII: "ユースフューチャーズ指数（YFI）とは？",
    fiiDescription: "YFIは3つの加重次元を使用して114カ国の若者の機会を測定します",
    mentalHealth: "メンタルヘルス",
    mentalHealthDesc: "メンタルヘルスの有病率、自殺率、サービスへのアクセス",
    workforcePreparation: "就労準備",
    workforceDesc: "若者の失業、スキル開発、教育達成度",
    entrepreneurship: "起業家精神",
    entrepreneurshipDesc: "ビジネス環境、起業支援、イノベーション",
    exploreFullIndex: "完全なインデックスを探索",
    memberExperience: "会員体験スナップショット",
    basedOnSurvey: "2025年会員調査に基づく",
    keyDemographics: "主要な人口統計",
    averageAge: "平均年齢",
    years: "歳",
    genderDistribution: "性別分布",
    male: "男性",
    female: "女性",
    other: "その他",
    employmentStatus: "雇用状況",
    fullTimeEmployed: "フルタイム雇用",
    entrepreneurSelfEmployed: "起業家/自営業",
    student: "学生",
    education: "教育",
    universityDegrees: "大学学位",
    regionalAgeRange: "地域別年齢範囲",
    youngest: "最年少",
    oldest: "最年長",
    membershipTenure: "会員期間",
    newMembersJoining: "新規会員加入中",
    buildingFoundation: "基盤構築中",
    growingLeadership: "リーダーシップ成長中",
    experiencedMembers: "経験豊富な会員",
    sustainedCommitment: "継続的なコミットメント",
    projectsAcrossRegions: "4地域のプロジェクト",
    demographicsMotivations: "人口統計とモチベーション",
    mentalHealthIndex: "メンタルヘルス指数",
    fiiWeight: "YFIの・グローバル危機データ",
    fiiRankingsAnalysis: "YFIインデックスと分析",
    digitalReach: "デジタルトレンドとイノベーション",
    howFIICalculated: "YFIの計算方法",
    conferencesPrograms: "JCI会議とプログラム",
    strategicGrowthTargets: "戦略的成長目標",
    regionalCouncils: "AMDEC、ADC、APDC、EDC",
    howToContribute: "貢献方法",
    frequentlyAskedQuestions: "よくある質問"
  },
  metrics: {
    membersActive: "アクティブ会員",
    countriesPresent: "存在する国",
    startupsSupported: "サポートされたスタートアップ",
    sustainableProjects: "持続可能なプロジェクト",
    completed: "完了",
    countries: "国",
    members: "会員",
    projects: "プロジェクト",
    projectsPerYear: "年間プロジェクト",
    memberDensity: "会員密度",
    country: "国",
    regionalDistribution: "地域別分布",
    globalPresence: "2025年のグローバルJCIプレゼンス",
    activeMembers: "アクティブ会員",
    globally: "世界的に",
    worldwidePresence: "世界的プレゼンス",
    communities: "コミュニティ",
    activeCommunities: "アクティブコミュニティ",
    yearsOfHistory: "歴史の年数",
    since1915: "1915年以来",
    vs2024: "2024年比",
    annualProjects: "年間プロジェクト",
    in2025: "2025年"
  },
  dashboardTenure: {
    lessThan1Year: "<1年",
    years1to3: "1-3年",
    years4to6: "4-6年",
    years7to9: "7-9年",
    moreThan10Years: ">10年",
    respondents: "回答者"
  },
  homeGlobalPresence: {
    title: "JCIグローバルプレゼンス",
    subtitle: "4地域の114カ国でアクティブ",
    regions: "地域",
    countries: "国",
    members: "会員",
    localOrgs: "ローカル組織"
  },
  globalPresenceMap: {
    title: "JCIグローバルプレゼンス",
    subtitle: "4地域の114カ国でアクティブ",
    countriesLabel: "カ国",
    regionsLabel: "地域",
    countriesCount: "国",
    membersCount: "会員",
    localOrgs: "ローカル組織",
    regions: {
      asiaPacific: "アジアと太平洋",
      europe: "ヨーロッパ",
      africaMe: "アフリカ・中東",
      americas: "アメリカ"
    }
  },
  observatoryHeader: {
    title: "JCIユースフューチャーズ・オブザーバトリー",
    subtitle: "開発評議会グローバル・オブザーバトリー",
    tagline: "変化する世界のためのリーダー育成",
    members: "会員",
    countries: "国",
    beneficiaries: "受益者",
    projects: "プロジェクト"
  },
  homeGlobalMap: {
    title: "JCIグローバルプレゼンス",
    subtitle: "114カ国でアクティブな若手リーダー",
    members: "会員",
    countries: "国",
    localOrgs: "ローカル組織",
    click: "詳細はクリック"
  },
  jciGlobalPresence: {
    title: "JCIグローバルプレゼンス",
    subtitle: "4地域の114カ国でアクティブ",
    countries: "カ国",
    orgs: "組織",
    regions: "地域",
    africaMiddleEast: "アフリカ・中東",
    americas: "アメリカ",
    asiaPacific: "アジアと太平洋",
    europe: "ヨーロッパ"
  },
  chartsAdvanced: {
    loading: "チャート読み込み中...",
    noData: "データがありません",
    error: "チャートの読み込みに失敗しました",
    xAxis: "X軸",
    yAxis: "Y軸",
    legend: "凡例",
    tooltip: "ツールチップ",
    zoom: "ズーム",
    pan: "パン",
    reset: "リセット",
    download: "ダウンロード"
  },
  digitalEcosystem: {
    title: "JCIデジタルエコシステム",
    subtitle: "会員のエンゲージメントとリーチを支えるデジタルプラットフォーム",
    website: "ウェブサイト",
    socialMedia: "ソーシャルメディア",
    magazine: "マガジン",
    activeUsers: "アクティブユーザー",
    followers: "フォロワー",
    readers: "読者",
    engagement: "エンゲージメント",
    reach: "リーチ",
    impressions: "インプレッション"
  },
  observatoryMastery: {
    title: "オブザーバトリーマスタリー",
    modulesExplored: "探索済みモジュール",
    outOf: "/",
    observer: "オブザーバー",
    analyst: "アナリスト",
    visionary: "ビジョナリー",
    keepExploring: "インサイトを解放するために探索を続けましょう！",
    almostThere: "もう少し！エキスパートになりつつあります。",
    masterAchieved: "オブザーバトリーをマスターしました！",
    unlockReward: "すべてのモジュールを訪問してエグゼクティブサマリーを解放",
    loginToTrack: "14のモジュールすべての探索進捗を追跡するにはログインしてください",
    signInToStart: "ログインして開始"
  },
  apiAnalytics: {
    title: "API分析",
    description: "APIの使用状況、パフォーマンス、トレンドを監視",
    last24Hours: "過去24時間",
    last7Days: "過去7日間",
    last30Days: "過去30日間",
    totalRequests: "リクエスト総数",
    successful: "成功",
    avgResponseTime: "平均応答時間",
    acrossAllEndpoints: "すべてのエンドポイント",
    errorRate: "エラー率",
    errors: "エラー",
    activeApiKeys: "アクティブなAPIキー",
    totalKeys: "キー総数",
    requestsOverTime: "時間経過によるリクエスト",
    requestsByDay: "日別APIリクエスト",
    requestsByEndpoint: "エンドポイント別リクエスト",
    distributionAcrossEndpoints: "APIエンドポイント間の分布",
    responseStatusCodes: "レスポンスステータスコード",
    distributionOfStatusCodes: "HTTPステータスコードの分布",
    topApiKeys: "上位APIキー",
    keysWithHighestUsage: "使用量の多いキー",
    active: "アクティブ",
    inactive: "非アクティブ",
    noApiKeysFound: "APIキーが見つかりません"
  }
} as const;
